

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { SkillCategory } from "@/lib/session-planning";
import { CATEGORY_DISPLAY } from "@/lib/session-planning";

type SkillCategoryBadgeProps = {
  category: SkillCategory;
  showEmoji?: boolean;
  showLabel?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
};

export function SkillCategoryBadge({
  category,
  showEmoji = true,
  showLabel = true,
  size = "md",
  className,
}: SkillCategoryBadgeProps) {
  const display = CATEGORY_DISPLAY[category];

  const sizeClasses = {
    sm: "text-xs px-1.5 py-0.5",
    md: "text-sm px-2 py-0.5",
    lg: "text-base px-3 py-1",
  };

  return (
    <Badge
      variant="outline"
      className={cn(
        sizeClasses[size],
        display.bgColor,
        display.borderColor,
        display.color,
        "font-medium",
        className
      )}
    >
      {showEmoji && <span className="mr-1">{display.emoji}</span>}
      {showLabel && display.labelShort}
    </Badge>
  );
}

type SkillCategoryIndicatorProps = {
  category: SkillCategory;
  className?: string;
};

export function SkillCategoryIndicator({
  category,
  className,
}: SkillCategoryIndicatorProps) {
  const display = CATEGORY_DISPLAY[category];

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 text-xs font-medium",
        display.color,
        className
      )}
    >
      <span>{display.emoji}</span>
      <span>{display.labelShort}</span>
    </span>
  );
}
